import React from "react";
import VittVichaar from "../assets/vitt-vichaar.png";
import Parinday from "../assets/parinday.png";
import Dhruvtara from "../assets/dhruvtara.png";

export default function Process() {
  return (
    <>
      <section className="bg-white">
        <div className=" container mx-auto">
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-800 text-center">
            Projects
          </h1>

          <div className="process-step grid grid-cols-1 gap-8 mt-8 xl:mt-12 xl:gap-8 md:grid-cols-2 xl:grid-cols-3">
            <div className="process-step flex flex-col items-center p-6 space-y-3  bg-white rounded-xl shadow-slate-200 shadow-xl backdrop-blur-xlrounded-xl ">
              <img src={VittVichaar} alt="" className="w-64" />
              <br />
              <h1 className="text-xl font-semibold text-gray-700 capitalize ">
                Project Vitt Vichaar
              </h1>
              <br />
              <p className="text-gray-500 text-justify">
                Project Vitt Vichaar is an initiative by LEO Club, University of
                Delhi, dedicated to promoting financial literacy with the
                empowering motto — "Money Simplified." The project aims to
                educate individuals, especially those from underprivileged
                backgrounds.
              </p>
              <a href="/vitt-vichaar">
                <button className="text-white bg-[#eab02a] px-28 py-4 text-lg rounded-md hover:bg-[#f6be3b] transition-colors duration-300 transform">
                  Find out more
                </button>
              </a>
            </div>

            <div className="process-step flex flex-col items-center p-6 space-y-3  bg-white rounded-xl shadow-slate-200 shadow-xl backdrop-blur-xl">
              <img src={Dhruvtara} alt="" className="w-64 " />
              <br />
              <h1 className="text-xl font-semibold text-gray-700 capitalize ">
                Project Dhruvtara
              </h1>
              <br />
              <p className="text-gray-500 text-justify">
                Project Dhruvtara is a flagship initiative by LEO Club,
                University of Delhi, aligned with the United Nations Sustainable
                Development Goal #4 – Quality Education. Rooted in the belief
                that education is the most powerful tool for empowerment.
              </p>
              <a href="/dhruvtara">
                <button className="text-white bg-[#00385B] px-28 py-4 text-lg rounded-md hover:bg-[#3b84b2] transition-colors duration-300 transform">
                  Find out more
                </button>
              </a>
            </div>

            <div className="process-step flex flex-col items-center p-6 space-y-3 text-center bg-white rounded-xl shadow-slate-200 shadow-xl backdrop-blur-xl">
              <img src={Parinday} alt="" className="w-64" />
              <br />
              <h1 className="text-xl font-semibold text-gray-700 capitalize ">
                Project Parinday
              </h1>
              <br />
              <p className="text-gray-500 text-justify  ">
                Project Parindey is a bold and transformative initiative
                launched by LEO Club, University of Delhi aimed at fostering
                awareness, inclusivity, and empowerment around topics that are
                often overlooked or stigmatized in society.
                <br /> <br />
              </p>
              <a href="/parinday">
                <button className="text-white bg-[#671832] px-28 py-4 text-lg rounded-md hover:bg-[#932e50] transition-colors duration-300 transform">
                  Find out more
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
